// @flow

import './style.scss';

import * as React from 'react';
import type { Node } from 'react';

import formatDate from 'utils/formatDate';
import Button from 'components/Button';

type Label = {
  id: number,
  name: string,
  color: string,
};

type Props = {
  title: string,
  createdAt: Date,
  updatedAt: Date,
  labels: Array<Label>,
  body: string,
  issueUrl: string,
  isListed?: boolean,
};

/**
 * @function SingleIssue
 * @param {Object} props
 * @param {string} props.title
 * @param {Date} props.createdAt
 * @param {Date} props.updatedAt
 * @param {Array<Label>} props.labels
 * @param {string} body
 * @param {string} issueUrl
 * @param {boolean} isListed
 * @returns {Node}
 * @exports SingleIssue
 */

export default function SingleIssue(props: Props): Node {
  const {
    title,
    createdAt,
    updatedAt,
    labels,
    body,
    issueUrl,
    isListed,
  } = props;
  return (
    <article
      className="SingleIssue"
      style={isListed ? { padding: '20px', margin: '20px 0' } : null}
    >
      <header className="SingleIssue__header">
        <h3 className="SingleIssue__title">{title}</h3>
      </header>
      <ul className="SingleIssue__labelsList ul-clear">
        {labels.map((label) => (
          <div className="SingleIssue__labelWrapper" key={label.id}>
            <div
              className="SingleIssue__labelColor"
              style={{ background: `#${label.color}` }}
            />
            <li className="SingleIssue__labelName" key={label.id}>
              {label.name}
            </li>
          </div>
        ))}
      </ul>
      <p className="SingleIssue__body">{body}</p>
      <footer className="SingleIssue__footer">
        <div className="SingleIssue__datewrapper">
          <span className="SingleIssue__createdAt">
            Created at {formatDate(createdAt)}
          </span>
          <span className="SingleIssue__updateAt">
            Last update at {formatDate(updatedAt)}
          </span>
        </div>
        <div className="SingleIssue__button">
          <Button
            href={issueUrl}
            onClick={() => {
              if (process.env.NODE_ENV === 'production')
                window.analytics.track('Go to issue clicked');
            }}
          >
            Go to issue
          </Button>
        </div>
      </footer>
    </article>
  );
}
SingleIssue.defaultProps = {
  isListed: true,
};
